const paths = {
  listSensor: '/sensor/list',
  editSensor: '/sensor/edit'
};

export default paths;
